import { htmlToText } from '@omnea-app/packages/universal/sanitize-html/sanitize'

// Captured so split keeps the tables themselves in the resulting segments.
const TABLE_BLOCK = /(<table\b[\s\S]*?<\/table>)/gi

const isTable = (segment: string) => /^<table\b/i.test(segment)

const markdownFromSegment = (segment: string): string =>
  segment
    .replace(/<\/p>/g, '\n') // Replace paragraph endings with newlines
    .replace(/<\/?strong>/g, '**') // Bold text using Markdown style
    .replace(/<\/?em>/g, '*') // Italic text using Markdown style
    .replace(/<li class="ql-indent-1">/g, '  - ') // Indented list
    .replace(/<li>/g, '- ') // Regular list
    .replace(/<\/li>/g, '\n') // List item end
    .replace(/<\/?ol>/g, '') // Remove ordered list tags
    .replace(/<\/?ul>/g, '') // Remove unordered list tags
    .replace(/<blockquote>/g, '> ') // Blockquotes
    .replace(/<\/blockquote>/g, '\n') // End blockquote
    .replace(/<[^>]+>/g, '') // Remove remaining HTML tags
    .replace(/\n+/g, '\n') // Collapse multiple newlines
    .trim()

// Tables are flattened by the shared parser-based helper rather than the replacements above: TipTap
// wraps every cell's content in a <p>, so a regex pass would break each cell onto its own line and
// lose the row structure. They stay in their own segments because htmlToText decodes entities, and
// a cell holding a literal "<" would then look like a tag to the remaining-tag stripper.
export const htmlToMarkdown = (text: string): string =>
  text
    .split(TABLE_BLOCK)
    .map((segment) => (isTable(segment) ? htmlToText(segment) : markdownFromSegment(segment)))
    .filter((segment) => segment !== '')
    .join('\n')
